import { components, GroupBase, SingleValueProps } from "react-select";

import type { SelectOption } from "../types";

export default function SelectSingleValue(
  props: SingleValueProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  const { data, children, selectProps } = props;

  const formattedValue = selectProps.formatOptionLabel
    ? selectProps.formatOptionLabel(data, {
        context: "value",
        inputValue: selectProps.inputValue,
        selectValue: selectProps.value,
      })
    : children;

  const usesDefaultSupportingLayout =
    Boolean(data.supportingText) && !selectProps.formatOptionLabel && children === data.label;

  return (
    <components.SingleValue {...props}>
      {usesDefaultSupportingLayout ? (
        <div className="cb-select__single-value-content">
          <span className="cb-select__single-value-label">{data.label}</span>
          <span className="cb-select__single-value-supporting">{data.supportingText}</span>
        </div>
      ) : (
        formattedValue
      )}
    </components.SingleValue>
  );
}
